import React from 'react';

import { func } from 'prop-types';

import Modal from '../Modal';

const GlobalModal = ({ modalRequest, ...props }) => {
  function onClose() {
    modalRequest({ ...props, open: false });
  }

  return <Modal {...props} onClose={onClose} />;
};

GlobalModal.propTypes = {
  modalRequest: func,
};

export default GlobalModal;
